export const iconFontAwesomeBuildingsBuildingCircleExclamation = (
	<i className="fa-solid fa-building-circle-exclamation"></i>
);
